import _ from "lodash";

export type LinkHandlers = Record<string, () => void>;

export const replaceLinks = (
  text: string,
  capitalizeLinks: boolean = true,
  handlers: LinkHandlers = {}
) => {
  return text
    .split(/(\{\{[^{}]+}}|{[^{}]+})/g)
    .map((part, index) => {

      const actionMatch = part.match(/^{{([^{}]+)}}$/);

      // FIX: Added actionMatch[1] check to satisfy strict null compiler rules
      if (actionMatch && actionMatch[1]) {
        const innerContent = actionMatch[1];

        // Check for the {{Label: URL}} pattern
        const colonIndex = innerContent.indexOf(":");
        if (colonIndex !== -1) {
          const label = innerContent.substring(0, colonIndex).trim();
          const url = innerContent.substring(colonIndex + 1).trim();

          return (
            <a
              key={index}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="underline cursor-pointer transition duration-200 hover:text-generic-hover hover:scale-105"
            >
              {capitalizeLinks ? _.startCase(label) : label}
            </a>
          );
        }

        // Fallback to the default {{action}} handler
        const action = innerContent;
        const handlerName = `open${_.upperFirst(action)}`;

        return (
          <a
            key={index}
            href="#"
            className="text-blue-600 underline cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              handlers[handlerName]?.();
            }}
          >
            {capitalizeLinks ? _.startCase(action) : action}
          </a>
        );
      }

      const linkMatch = part.match(/^{([^{}]+)}$/);

      // FIX: Added linkMatch[1] check to safeguard single brace captures too
      if (linkMatch && linkMatch[1]) {
        const link = linkMatch[1];

        return (
          <a
            key={index}
            href={`/${link}`}
            className="underline cursor-pointer transition duration-200 hover:text-generic-hover hover:scale-105"
          >
            {capitalizeLinks ? _.startCase(link) : link}
          </a>
        );
      }

      return part;
    });
};